import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment-timezone';
import { ConcessaoService } from 'src/app/modules/shared/services/concessao/concessao.service';
import { SercretariasService } from 'src/app/modules/shared/services/secretarias/sercretarias.service';
import { OpenSnackbarService } from 'src/app/modules/shared/services/snackBar/open-snackbar.service';
import { cepValidator } from '../../../validators/cep-validator';
import { cpfValidator } from '../../../validators/cpf-validator';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { EntitiesService } from 'src/app/modules/entidade/services/entities.service';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-modal-filters',
  templateUrl: './modal-filters.component.html',
  styleUrls: ['./modal-filters.component.scss'],
})
export class ModalFiltersComponent implements OnInit {
  form!: FormGroup;
  formContract!: FormGroup;
  concessaoTypes: any[] = [];
  secretarias: any[] = [];
  tipoEntidadeInput: string = '';
  selectTipoEntidadeId: any = null;
  isMobile: boolean = false;
  entities: any[] = [];
  isRitDisabled: boolean = false;
  isNameDisabled: boolean = false;
  isCPFDisabled: boolean = false;
  isCEPDisabled: boolean = false;
  isEmailDisabled: boolean = false;
  isTypeDisabled: boolean = false;

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public filters_data: any,
    private concessionService: ConcessaoService,
    private snackbarService: OpenSnackbarService,
    private secretariasServices: SercretariasService,
    private breakpointObserver: BreakpointObserver,
    private entitiesService: EntitiesService,
    private toastService: ToastService,
  ) {
    iconRegistry.addSvgIcon(
      'filter-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/create-user/svgs/trailing-icon.svg',
      ),
    );

    iconRegistry.addSvgIcon(
      'eraser-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/create-user/svgs/eraser.svg',
      ),
    );

    this.form = this.fb.group({
      cep: ['', [cepValidator()]],
      cpfRepLegal: ['', [cpfValidator()]],
      nomeRepLegal: [''],
      emailEmpresa: [''],
      rit: [''],
      tipoEntidade: [''],
      tipoEntidadeId: [''],
    });

    this.formContract = this.fb.group({
      tipoConcessao: [''],
      secretaria: [''],
      dataAssinatura: [''],
      dataEficacia: [''],
      prorrogavelAte: [''],
      medidaProrrogavelAte: [''],
    });
  }

  ngOnInit(): void {
    if (this.filters_data.type == 'entitie') {
      this.checkPopulating(this.filters_data);
    } else {
      this.getFilterDatas();
    }

    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    this.getEntitieTypes();
  }

  onSelectTipoEntidadeInput(value: any) {
    this.setFormValue(value, 'tipoEntidade');
  }

  onSelectTipoEntidadeId(value: any) {
    this.setFormValue(value, 'tipoEntidadeId');
  }

  setFormValue(value: any, formInput: any) {
    if (value) {
      return this.form.patchValue({ [formInput]: value });
    }
    return this.form.patchValue({ [formInput]: null });
  }

  getEntitieTypes() {
    this.entitiesService
      .getEntitiesTypes()
      .pipe(take(1))
      .subscribe(
        (resp: any) => {
          this.entities = resp;
        },
        (erro) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      );
  }

  validateNumberInput(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 3);
    this.form.get('rit')?.setValue(input.value);
  }

  getFilterDatas() {
    this.concessionService.getConcessionTypes().subscribe({
      next: (res: any) => {
        this.concessaoTypes = res;
      },
      error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error');
      },
    });
    this.secretariasServices.getSecretarias().subscribe({
      next: (res: any) => {
        this.secretarias = res;
      },
      error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error');
      },
    });
  }

  resetErrorState(field: string) {
    const control = this.form.get(field);
    control?.markAsPristine();
    control?.markAsUntouched();
    control?.updateValueAndValidity();
  }

  checkPopulating(values: any) {
    if (this.filters_data.cep != '') {
      this.form.patchValue({
        cep: values.cep,
      });
      this.form.get('cep')?.disable();
      this.isCEPDisabled = true;
    }

    if (this.filters_data.cpfRepLegal != '') {
      this.form.patchValue({
        cpfRepLegal: values.cpfRepLegal,
      });
      this.form.get('cpfRepLegal')?.disable();
      this.isCPFDisabled = true;
    }

    if (this.filters_data.nomeRepLegal != '') {
      this.form.patchValue({
        nomeRepLegal: values.nomeRepLegal,
      });
      this.form.get('nomeRepLegal')?.disable();
      this.isNameDisabled = true;
    }
    if (this.filters_data.emailEmpresa != '') {
      this.form.patchValue({
        emailEmpresa: values.emailEmpresa,
      });
      this.form.get('emailEmpresa')?.disable();
      this.isEmailDisabled = true;
    }
    if (this.filters_data.typeEntitie != '') {
      const entidadeSelecionada = this.entities.find(
        (ent) => ent.name === this.filters_data.typeEntitie,
      );

      if (entidadeSelecionada) {
        this.selectTipoEntidadeId = entidadeSelecionada.id;
      }

      this.onSelectTipoEntidadeInput(this.filters_data.typeEntitie);
      this.isTypeDisabled = true;
    }
    if (this.filters_data.rit && this.filters_data.rit != '') {
      this.form.patchValue({
        rit: values.rit,
      });
      this.form.get('rit')?.disable();
      this.isRitDisabled = true;
    }
  }

  enableFormFields(form: FormGroup) {
    Object.keys(form.controls).forEach((field) => {
      form.get(field)?.enable();
    });
  }

  filter() {
    if (this.filters_data.type === 'entitie') {
      this.dialogRef.close(this.form.value);
      this.dialogRef.close(this.form.value);
    } else {
      const data = {
        dataAssinatura: moment(this.formContract.value.dataAssinatura),
        dataEficacia: moment(this.formContract.value.dataEficacia),
        ...this.formContract.value,
      };
      this.dialogRef.close(this.formContract.value);
    }
  }

  close() {
    this.dialogRef.close();
  }

  clear() {
    this.form.patchValue({
      emailEmpresa: '',
      cep: '',
      nomeRepLegal: '',
      cpfRepLegal: '',
      rit: '',
      tipoEntidade: '',
      tipoEntidadeId: '',
    });
    this.enableFormFields(this.form);
    this.dialogRef.close(this.form.value);
  }
}
